import React from "react";
import { withRouter } from "react-router";
import styled, { withTheme } from "styled-components/native";
import { Link } from "cci-utility";
import Icon from "../icon/FontAwesomePro";

// Wrapper for a list row that adds the padding and any styling to the entire row
const RowWrapper = styled.View`
  ${props => props.theme.listRowStyle}

  ${ ({ to, location, theme }) => to.pathname === location.pathname && theme.selectedListRowStyle }

  flex-direction: row;
  align-items: center;
`;

/**
 * Row component that calls another page when the row is pressed.
 * 
 * Props:
 * - to: Object containing the target page that the user must be taken to when the row is pressed. See react-router's to prop for details.
 */
const LinkedRow = ({theme, to, children, ...restProps}) => (
  <Link to={to}>
    <RowWrapper {...{to, theme, ...restProps}}>
      {children}

      <Icon
        name="chevron-right"
        color={theme.list.arrowColor || theme.fontColor}
        iconSize={12}
        weight={theme.list.arrowWeight || 300}
        margins="0 0 0 auto"
      />
    </RowWrapper>
  </Link>
);

export default withRouter(withTheme(LinkedRow));
